import type { WidgetLoginResponse } from '../types/widget-login.js';
import { MOCK_WIDGET_SETTINGS } from './mock-settings.js';

function isReengageSmoke(): boolean {
  try {
    const env = (import.meta as { env?: Record<string, string | undefined> })
      .env;
    return (
      env?.VITE_TEO_REENGAGE_SMOKE === 'true' ||
      env?.VITE_TEO_REENGAGE_SMOKE === '1'
    );
  } catch {
    return false;
  }
}

export const MOCK_WIDGET_LOGIN: WidgetLoginResponse = {
  id: 88,
  company_id: 11,
  module_type: 300,
  token: 'mock-token-teo-widget',
  settings: MOCK_WIDGET_SETTINGS,
  // Reengage smoke starts without a dialog so first popup → send → dwell can run.
  thread_id: isReengageSmoke() ? null : 5753,
};
